import React from "react";
import UsersList from "./UsersList";
import { useRouteMatch } from "react-router-dom";
import UserDetail from "./UserDetail";
import CrumbsProvider from "../../../../Misc/CrumbsProvider";
import UserAdd from "./UserAdd";

export default function Users() {
  let routeMatch = useRouteMatch({
    path: "/admin/users/:userId/",
    strict: true,
    sensitive: true,
  });
  let userId = routeMatch ? routeMatch.params["userId"] : false;

  let contentComponent = <UsersList />;
  if (userId) contentComponent = <UserDetail userId={userId} />;
  if (userId === "add") contentComponent = <UserAdd />;

  return (
    <>
      <CrumbsProvider title="Пользователи" link="/admin/users/" />
      {contentComponent}
    </>
  );
}
